import _groupBy from 'lodash/groupBy';
import _findIndex from 'lodash/findIndex';
import _head from 'lodash/head';
import _map from 'lodash/map';
import _filter from 'lodash/filter';

import equal from 'deep-equal';

import {
    CART_ADD,
    CART_UPDATE,
    CART_REMOVE,
    CART_CLEAN,
    ADDRESS_AVAILABLE_OPTIONS_SET,
    ADDRESS_UPDATE_INFO,
    ADDRESS_SHOULD_UPDATE_AVAILABLE_OPTIONS,
    ADDRESS_OPTIONS_CLEAN,
    PERSONAL_SET_COUNTRY,
    PERSONAL_SET_CURRENCY,
} from '../actions/actionTypes';

import Currencies from '../services/currencies';


const groupBySeller = (cartByHash) => _groupBy(cartByHash, (value, key) => value['seller_id']);

const createShippingOption = (key, seller_name, country, shippingOptions) => {
    let CountryIndex = _findIndex(shippingOptions, ['name', country]);
    if (CountryIndex >= 0) {
        return {
            'key': key,
            'seller_id': key,
            'seller_name': seller_name,
            'country': country,
            'shippingOptions': shippingOptions[CountryIndex]
        }
    } else {
        return {
            'key': key,
            'seller_id': key,
            'seller_name': seller_name,
            'country': country,
            'shippingOptions': false
        }
    }
};

const createShippingOptions = (props) =>
    _filter(
        _map(
            groupBySeller(
                _filter(props.cart.byHash, (item) => !item.content.is_digital)), (item, index) => {
                const product = _head(item);
                return createShippingOption(
                    index,
                    product.seller_name,
                    props.personal.country,
                    product.shipping_zones
                )
            }
        )
    );

const shippingMiddleware = store => next => action => {

    next(action);

    let actions = [
        CART_ADD,
        CART_UPDATE,
        CART_REMOVE,
        CART_CLEAN,
        ADDRESS_SHOULD_UPDATE_AVAILABLE_OPTIONS,
        PERSONAL_SET_COUNTRY,
        PERSONAL_SET_CURRENCY
    ];

    let shouldAct = _findIndex(actions, function (o) {
        return o === action.type;
    });

    if (shouldAct >= 0) {
        const state = store.getState();
        const oldShippingOptions = {...state.shipping.availableOptions};
        const shippingOptions = createShippingOptions(state);

        if (!equal(oldShippingOptions, shippingOptions)) {
            store.dispatch({type: ADDRESS_AVAILABLE_OPTIONS_SET, payload: shippingOptions});
            store.dispatch({type: ADDRESS_OPTIONS_CLEAN});
        }

    }

    if (action.type === ADDRESS_UPDATE_INFO) {
        //If address country changes we should change country in common, change currency, change available shipping options, maybe remove selected shipping options
        if (action.address_type === 'shipping' && action.key === 'country') {
            //Change country
            store.dispatch({type: PERSONAL_SET_COUNTRY, payload: action.value});
            //Change currency (products can override this)
            const countryCurrency = Currencies.getCurrencyByCountry(action.value);
            const currency = _head(countryCurrency.currencies);
            store.dispatch({type: PERSONAL_SET_CURRENCY, payload: currency.code});
            //Change shipping options
            store.dispatch({type: ADDRESS_SHOULD_UPDATE_AVAILABLE_OPTIONS});
        }
    }
};

export default shippingMiddleware